<template>
  <div class="container">
    <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th class="text-right">ID</th>
          <th>Nombre</th>
          <th>Telefono</th>
          <th>Email</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="empleados == null">
          <td colspan="5">
            <h4 class="text-center">
              <b-spinner label="Loading..."></b-spinner>
              Cargando Datos
            </h4>
          </td>
        </tr>
        <tr v-for="(e, i) in empleados" :key="i" v-else>
          <td class="text-right" style="padding:0">
            <router-link
              class="btn btn-primary btn-block"
              :to="{ name: 'RepartidoresVer', params: { id: e.empleado_id } }"
            >
              <i class="fas fa-info-circle" style="float:left;color:white"></i>
              {{ e.empleado_id }}
            </router-link>
          </td>
          <td>{{ e.empleado.nombre }}</td>
          <td>{{ e.telefono }}</td>
          <td>{{ e.email }}</td>
          <td class="actions">
            <b-button
              class="btn btn-danger btn-block"
              @click="abrir_modal_genPin(e.empleado)"
            >
              <i class="fas fa-key"></i> Resetear PIN
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
    <hr />
    <router-link
      class="btn btn-primary btn-block"
      :to="{ name: 'RepartidoresAgregar' }"
    >
      <i class="fas fa-plus"></i> Agregar repartidor
    </router-link>
    <!-- Modal cambiar PIN -->
    <b-modal id="resetear-pin-modal" hide-footer>
      <template v-slot:modal-title>
        Generar <strong>PIN</strong> de acceso para el usuario
        <code>{{ pin_data.empleado_id }}</code>
      </template>
      <div class="d-block text-center">
        <label for="basic-url">PIN del usuario</label>
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon3">
              <i class="fas fa-key"></i>
            </span>
          </div>
          <input
            placeholder="Generar PIN"
            type="text"
            class="form-control"
            :value="pin_data.pin"
            aria-describedby="basic-addon3"
            @click="select_pin"
            style="text-align:right;"
            id="input-pin-usuario"
            @blur="blur_input_pin"
          />
          <b-tooltip
            placement="topright"
            variant="info"
            ref="input-pin-usuario"
            triggers=""
            target="input-pin-usuario"
          >
            ¡<strong>PIN</strong> copiado!
          </b-tooltip>
        </div>
      </div>
      <b-button
        class="mt-3"
        block
        @click="cerrar_modal_genPin"
        v-if="pin_data.pin"
      >
        Cerrar
      </b-button>
      <b-button class="mt-3" block @click="generar_pin" variant="danger" v-else>
        Generar
      </b-button>
    </b-modal>
    <!-- Modal cambiar PIN -->
  </div>
</template>

<style lang="scss"></style>

<script>
import UserApi from "../../apis/User";

export default {
  name: "RepartidoresIndex",
  data() {
    return {
      empleados: null,
      pin_data: {
        empleado_id: null,
        pin: ""
      },
      controls: {
        current_page: 1,
        per_page: 10,
        total: 0,
        query: "",
        sort_column: "id",
        sort_order: "desc"
        // relations: ["users"]
      },
      fields: [
        { display: "Folio", field: "id", sort: true },
        { display: "Nombre", field: "name", sort: true },
        { display: "Correo", field: "email", sort: true },
        { display: "Telefono", field: "telefono", sort: true },
        { display: "Registro", field: "stock", sort: true },
        { display: "Acciones" }
      ]
    };
  },
  created() {
    UserApi.paginate({}).then(d => {
      this.empleados = d.data;
    });
  },
  components: {},
  methods: {
    abrir_modal_genPin: function(e) {
      this.pin_data.empleado_id = e.id;
      this.pin_data.pin = "";
      this.$bvModal.show("resetear-pin-modal");
    },
    cerrar_modal_genPin: function() {
      this.pin_data.pin = "";
      this.$bvModal.hide("resetear-pin-modal");
    },
    generar_pin: function() {
      UserApi.generar_pin(this.pin_data.empleado_id).then(pin => {
        this.pin_data.pin = pin;
      });
    },
    select_pin: function(event) {
      if (!event.target.value) {
        return;
      }
      event.target.select();
      document.execCommand("copy");
      this.$refs["input-pin-usuario"].$emit("open");
    },
    blur_input_pin: function() {
      if (
        Object.prototype.hasOwnProperty.call(this.$refs, "input-pin-usuario")
      ) {
        this.$refs["input-pin-usuario"].$emit("close");
      }
    }
  }, // end methods
  computed: {}
};
</script>
